import LegalDocument from '../components/legal/LegalDocument';

export default function TermsPage() {
    return <LegalDocument kind="terms" />;
}
